import request from "@/util/request.js";
export const getMarket = () =>
  request({
    url: "/wms/wx/officialAccount/metalPrice",
    method: "GET",
  });

/**
 * k线图页面数据
 */
export const getkLine = (params) =>
  request({
    url: `/wms/wx/officialAccount/metalPrice/detail`,
    method: "GET",
    params,
  });
